import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

const EmptyAdditionOrderProducts = () => {
  return (
    <div className='flex h-[436px] flex-col items-center justify-center gap-[16px]'>
      <div className='flex flex-col items-center justify-center gap-[16px]'>
        <MaterialIcon name='upcoming' size={48} color={theme.color.gray100} filled />
        <p className='typography-ui-15m text-gray-400'>상품을 준비하고 있어요</p>
      </div>
    </div>
  );
};

export default EmptyAdditionOrderProducts;
